module.exports = __webpack_public_path__ + "img/event_promo_private_workshops.07f22972.jpg";